import { createAction } from '@reduxjs/toolkit';

import { withPayloadType } from 'utils';

export const resendConfirmationEmailStart = createAction(
  'RESEND_CONFIRMATION_EMAIL::START',
  withPayloadType<{ email: string }>(),
);
